<template>
    <v-dialog v-model="mostrar" persistent max-width="70vw" scrollable>
		<v-card max-height="600px" :loading="loading">
            <template slot="progress">
                <v-progress-linear color="primary" indeterminate></v-progress-linear>
            </template>
			<v-toolbar flat :color="this.$store.state.title == 'Calendario' ? this.$store.state.corEvento : cor"></v-toolbar>
			<v-divider></v-divider>
            <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="6">
                        <v-text-field label="Código" v-model="perfil.id_perfil" readonly disabled outlined></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field label="Nome" v-model="perfil.nome" outlined></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols=12>
                        <v-data-table :height="this.$store.getters.alturaContent - 550"  hide-default-footer locale="pt-BR" dense fixed-header class="table-item" :items="acessos" :headers="fields" :items-per-page="itensPerPage">
                            <template v-slot:item.ativo="{ item }">
                                <v-simple-checkbox v-model="item.ativo"></v-simple-checkbox>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
            </v-card-text>
            <v-card-actions>
				<v-spacer></v-spacer>
				<v-btn text color="primary" @click.stop="salvar()">Salvar</v-btn>
				<v-btn text color="primary" @click.stop="fechar()">Fechar</v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>    
</template>

<script>
import metodos from '@/mixins/metodos'
import { baseApiUrl, showError, showSuccess } from "@/config/global"
import axios from 'axios'


export default {
    name: 'edicaoPerfilAcesso',
    props:['mostrar', 'perfil', 'acessos'],
    mixins: [metodos],
    data(){
        return{
            loading: false,
            cor: 'primary',
            itensPerPage: 100,
            fields:[
                {text: "Código", value: 'id_item'},
                {text: 'Nome', value: 'nome_item'},
                {text: 'Tipo', value: 'tipo_acesso'},
                {text: 'Ativo', value: 'ativo'}
            ]
        }
    },

    methods:{
        salvar(){
            this.loading = true
            let prf = {
                id_perfil: this.perfil.id_perfil,
                nome: this.perfil.nome,
                acessos: this.acessos
            }
            const url = `${baseApiUrl}/Cadastros/perfis/update.php`
					
			axios.post(url, prf)
                .then(res => { 
                if(res.data.codigo == '01'){
                    showSuccess(res.data.mensagem)
                    this.fechar()
                    this.loading = false
                }else{
                    showError(res.data.mensagem)
                    this.loading = false
                }
            })
        },

        fechar(){
            this.perfil = {}
            this.$emit("fechar");
        }
    }
}
</script>

<style scoped>

</style>